module.exports = __webpack_public_path__ + "img/feature_4.0e1e4fcc.svg";